import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import _ from "lodash";
import { apiCallBegan } from "./api";
import {
  arrayToObject,
  arrayToObjectForMyQuotes,
  convertArrayOfObjectsToId,
  PossibleClientDetailsStatus,
} from "./helperfuncs";

const slice = createSlice({
  name: "myquotes",
  initialState: {
    archiveStatus: false,
    gettingMyQuotes: false,
    gettingMyCharge: false,
    gettingMyQuotesFailed: false,
    gettingMyChargeFailed: false,
    gettingCreateChargeSuccess: false,
    gettingMyQuotesSuccess: false,
    freshProspectInProspectOrder: false,
    prospectorder: []
  },
  reducers: {
    // action => action handler
    gettingPaymentSuccess: (myquotes, action) => {
      myquotes.selectedPaymentDetails = action.payload;
    },
    gettingDeleteCardSuccess: (myquotes, action) => {
      myquotes.selectedCardDetails = action.payload;
    },
    gettingDefaultCardSuccess: (myquotes, action) => {
      myquotes.selectedDefaultCard = action.payload;
    },
    gettingCreateChargeSuccess: (myquotes, action) => {
      myquotes.selectedCreateCharge = action.payload;
    },
    gettingPaymentInitialized: (myquotes, action) => {
      myquotes.gettingMyQuotes = true;
      myquotes.gettingMyQuotesFailed = false;
      myquotes.gettingMyQuotesSuccess = false;
    },

    gettingPaymentFailed: (myquotes, action) => {
      myquotes.gettingMyQuotes = false;
      myquotes.gettingMyQuotesFailed = true;
      myquotes.gettingMyQuotesSuccess = false;
    },
    gettingQuotesInitialized: (myquotes, action) => {
      myquotes.gettingMyQuotes = true;
      myquotes.gettingMyQuotesFailed = false;
      myquotes.gettingMyQuotesSuccess = false;
    },
    gettingCreateChargeInitialized: (myquotes, action) => {
      myquotes.gettingMyCharge = true;
      myquotes.gettingMyChargeFailed = false;
      myquotes.gettingCreateChargeSuccess = false;
    },
    gettingChargeFailed: (myquotes, action) => {
      myquotes.gettingMyQuotes = false;
      myquotes.gettingMyChargeFailed = true;
      myquotes.gettingCreateChargeSuccess = false;
    },
    gettingQuotesFailed: (myquotes, action) => {
      myquotes.gettingMyQuotes = false;
      myquotes.gettingMyQuotesFailed = true;
      myquotes.gettingMyQuotesSuccess = false;
    },

    gettingMyQuotesSuccess: (myquotes, action) => {
      myquotes.gettingMyQuotes = false;
      myquotes.gettingMyQuotesFailed = false;
      myquotes.gettingMyQuotesSuccess = true;
      myquotes.prospectorder = action.payload.prospectorder;
      myquotes.order = convertArrayOfObjectsToId(
        action.payload.prospectorder,
        "prospectid"
      );
      myquotes.table = arrayToObjectForMyQuotes(
        action.payload.prospectorder,
        "prospectid"
      );
      myquotes.cached = action.payload.cachedCopy;
    },
    archivedProspectInitialized: (myquotes, action) => {
      myquotes.archiveStatus = false;
    },
    archivedProspectSuccess: (myquotes, action) => {
      myquotes.archiveStatus = true;
      let tempData = myquotes.table;
      myquotes.order = myquotes.order.filter(
        (e) => e !== action.payload.prospectid
      );
      delete tempData[action.payload.prospectid];
    },
    gettingClientDetailsInitialized: (myquotes, action) => {
      myquotes.table[action.payload.prospectid].clientdetails =
        PossibleClientDetailsStatus.loading;
    },
    gettingClientDetailsSuccess: (myquotes, action) => {
      myquotes.table[action.payload.extras.prospectid].clientdetails =
        action.payload.response.clientdetails;
    },
    gettingClienteDetailsFailed: (myquotes, action) => {
      myquotes.table[action.payload.extras.prospectid].clientdetails =
        PossibleClientDetailsStatus.failed;
    },
    gettingSearchResultsSuccess: (myquotes, action) => {
      myquotes.searchedProspectIDs = action.payload.prospectIDs;
    },
    gettingAllCardSuccess: (myquotes, action) => {
      myquotes.getAllCards = action.payload.cards;
    },
    appendtoProspectOrder: (myquotes, action) => {
      let found = myquotes.prospectorder?.find(x => x.prospectid == action.payload.prospectid)
      if(!found){
        myquotes.prospectorder = [...myquotes.prospectorder, action.payload];
        myquotes.freshProspectInProspectOrder = true;
      } else {
        myquotes.freshProspectInProspectOrder = true;
      }
    },
  },
});

export const {
  gettingDeleteCardSuccess,
  gettingDefaultCardSuccess,
  gettingCreateChargeSuccess,
  gettingPaymentInitialized,
  gettingPaymentSuccess,
  gettingPaymentFailed,
  gettingQuotesInitialized,
  gettingCreateChargeInitialized,
  gettingMyQuotesSuccess,
  gettingQuotesFailed,
  gettingChargeFailed,
  archivedProspectSuccess,
  archivedProspectInitialized,
  gettingClientDetailsInitialized,
  gettingClienteDetailsFailed,
  gettingClientDetailsSuccess,
  gettingSearchResultsSuccess,
  gettingAllCardSuccess,
  appendtoProspectOrder,
} = slice.actions;

export default slice.reducer;

// Action Creators

export const getMyQuotes = (data) => {
  var url = data
    ? "/api/prospects/get-my-prospects?" +
      Object.keys(data)
        .reduce(function (a, k) {
          a.push(k + "=" + encodeURIComponent(data[k]));
          return a;
        }, [])
        .join("&")
    : "/api/prospects/get-my-prospects";
  return apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: url,
    method: "get",
    onStart: gettingQuotesInitialized.type,
    onSuccess: gettingMyQuotesSuccess.type,
    onError: gettingQuotesFailed.type,
  });
};

export const allPaymentCard = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/retrive-cards",
    method: "get",
    onStart: gettingQuotesInitialized.type,
    onSuccess: gettingAllCardSuccess.type,
    onError: gettingQuotesFailed.type,
  });

export const addPaymentCard = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/add-card",
    method: "post",
    data: data,
    onStart: gettingPaymentInitialized.type,
    onSuccess: gettingPaymentSuccess.type,
    onError: gettingPaymentFailed.type,
  });
export const deletePaymentCard = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/delete-card",
    method: "post",
    data: data,
    onStart: gettingQuotesInitialized.type,
    onSuccess: gettingDeleteCardSuccess.type,
    onError: gettingQuotesFailed.type,
  });
export const defaultPaymentCard = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/add-default-card",
    method: "post",
    data: data,
    onStart: gettingQuotesInitialized.type,
    onSuccess: gettingDefaultCardSuccess.type,
    onError: gettingQuotesFailed.type,
  });
export const createCharge = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/create-charge",
    method: "post",
    data: data,
    onStart: gettingCreateChargeInitialized.type,
    onSuccess: gettingCreateChargeSuccess.type,
    onError: gettingChargeFailed.type,
  });
export const searchProspects = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/searchprospects?q=" + data,
    method: "get",
    onSuccess: gettingSearchResultsSuccess.type,
  });
export const archiveProspect = ({ prospectid }) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/archiveProspect",
    method: "post",
    data: { prospectid },
    onStart: archivedProspectInitialized.type,
    onSuccess: archivedProspectSuccess.type,
    onSuccessPayload: { prospectid },
  });
export const getClientDetailsUsingProspectId = ({ prospectid }) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/propsectclientdetails",
    method: "post",
    data: { prospectid },
    onStart: gettingClientDetailsInitialized.type,
    onSuccess: gettingClientDetailsSuccess.type,
    onError: gettingClienteDetailsFailed.type,
    considerPayloads: true,
    onStartPayload: { prospectid },
    onSuccessPayload: { prospectid },
    onErrorPayload: { prospectid },
  });

export const updateScratchpad = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/upsert-scratchpad",
    method: "post",
    data: data,
    onStart: true,
    onSuccess: true,
    onError: true,
  });

// selectors

export const getGettingMyQuotes = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingMyQuotes
);

export const getGettingMyQuotesSuccess = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingMyQuotesSuccess
);

export const getProspectaddedProspectOrder = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.freshProspectInProspectOrder
);

export const getMyQuotesCached = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.cached
);

export const getGettingMyQuotesFailed = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingMyQuotesFailed
);

export const getArrayOfProspectsId = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.order
);

export const getSearchedProspectsArray = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.searchedProspectIDs
);
export const getGettingPaymentSuccess = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.selectedPaymentDetails
);
export const deleteCardSuccess = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.selectedCardDetails
);
export const defaultCardSuccess = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.selectedDefaultCard
);
export const createChargeSuccess = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.selectedCreateCharge
);
export const createChargeInitialized = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingCreateChargeInitialized
);
export const createChargeFailed = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingChargeFailed
);
export const getDefaultCardInitialized = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingMyQuotesSuccess
);
export const getDefaultCardFailed = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.gettingMyQuotesFailed
);
export const getArchiveStatus = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.archiveStatus
);
export const getFilteredProspectsIdArray =
  (broker, status, vertical, startdate, enddate, pids) => (state) => {
    var s = [];
    if (state.entities.myquotes.table) {
      for (const item of state.entities.myquotes.order) {
        let pros = state.entities.myquotes.table[item];
        if (pids && !pids.includes(pros.prospectid)) continue;
        if (startdate && pros.lastupdated < startdate) continue;
        if (enddate && pros.lastupdated > enddate) continue;
        if (broker != "" && pros.brokername != broker) continue;
        if (status != "" && pros.status != status) continue;
        if (
          vertical != "" &&
          pros.vertical["en"] != vertical &&
          pros.vertical["fr"] != vertical
        )
          continue;
        s.push(item);
      }
    }
    return s;
  };

export const getQuotes = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes
);
export const getAllCardsInformation = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => myquotes.getAllCards
);
export const getBrokers = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => {
    var s = [];
    if (myquotes.order) {
      for (const item of myquotes.order) {
        let bname = myquotes.table[item].brokername;
        if (!s.includes(bname)) s.push(bname);
      }
    }
    return s;
  }
);

export const getStatus = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => {
    var s = [];
    if (myquotes.order) {
      for (const item of myquotes.order) {
        let sname = myquotes.table[item].status;
        if (!s.includes(sname)) s.push(sname);
      }
    }
    return s;
  }
);

export const getVertical = createSelector(
  (state) => state.entities.myquotes,
  (myquotes) => {
    var s = [];
    if (myquotes.order) {
      for (const item of myquotes.order) {
        let bname = myquotes.table[item].vertical;
        if (!s.includes(bname)) s.push(bname);
      }
    }
    return s;
  }
);

export const getRowDetailsFromProspectId =
  ({ prospectid }) =>
  (state) => {
    if (state.entities.myquotes && state.entities.myquotes.table)
      return state.entities.myquotes.table[prospectid];
    return {};
  };

export const getClientDetailStatus =
  ({ prospectid }) =>
  (state) =>
    state.entities.myquotes.table[prospectid]
      ? state.entities.myquotes.table[prospectid].clientdetails
      : {};

export const getAllProspectsforCustomer =
  ({ prospectids }) =>
  (state) => {
    var pros_arr = [];
    if (state.entities.myquotes && state.entities.myquotes.table)
    {
      prospectids?.map(prospectid => state.entities.myquotes.table[prospectid] ? pros_arr.push(state.entities.myquotes.table[prospectid]) : null );
    }
    //console.log(state.entities.myquotes)
    for(var key in pros_arr){
      pros_arr[key] = {
        'Type': 'Opportunity',
        'Action' : {'type':'select', 'options':['View / Edit Application', 'View Marketing (Digitial Marketing Hub)',  'View Transaction History', 'Send to Market']},
        'Status': pros_arr[key].status,
        'Last Updated': pros_arr[key].lastupdated ? new Date( pros_arr[key].lastupdated ).toLocaleString(undefined, {dateStyle: 'short'}) : '',
        'Insurer': '',
        'Start Date' : '',
        'Expiry Date' : '',
        'Id': pros_arr[key].prospectid.slice(-4),
        'prospectid': pros_arr[key].prospectid,
        'productcode': pros_arr[key].productcode
      }
    }
    return pros_arr;
  };